import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "©kodljivo?",
  "description": "",
  "published": "2006-08-09T00:00:00.000Z",
  "redirect_from": ["/blog/kodljivo/swizec/389"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Prvo, kot prvo, verjetno ste opazili, da stripa nekako še ni na svojem dodeljenem mestu, ki je gor, èeprav je bilo obljubljeno, da bo dotièni srip do trenutnega trenutka ¾e davno na voljo. Do razlik med fikcijo in realnostjo je prišlo po nekaj preprostih korakih. Prvi korak je bil ta, da ima dotièni èlovek, ki stripe ustvarja praktièno dvojno zaposlen, se pravi ena polna zaposlitev in ena honorarna (èeprav sta v bistvu obe honorarni). Drugi korak je bil, da se je raèunalnik, na katerem se odvija vse delo, odloèil biti nesramna baraba in imeti napako na disku natanko tam, kjer so bili do nedavnega vsi deli stripa oz. skoraj vsi ti deli. Sedaj je potrebno vse še enkrat ustvariti in trenutno sem v procesu ustvarjanja kakor hitro zmorem.`}</p>
    <p>{`S tem smo torej opravili, zdaj pa k zanimiv reèem. Èlan `}<a parentName="p" {...{
        "href": "http://cad-forums.com"
      }}>{`CAD forumov`}</a>{` je odkril zanimivo stran, ki natanèno opisuje izdelavo, delovanje in uporabo naprave, ki spreminja tek èasa. Seveda te spremembe niso prave, ampak nekako navidezne, efekti so kljub temu odlièni. `}<a parentName="p" {...{
        "href": "http://cre.ations.net/creation/44"
      }}>{`Tam`}</a>{` je tudi prelep video prikaz vsega skupaj in... ogled je neizbe¾en, èe uidete `}<a parentName="p" {...{
        "href": "http://cre.ations.net/creation/44"
      }}>{`temu`}</a>{` ste... nenavadni, milo reèeno.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      